import { FC } from 'react';
import { Globe } from 'lucide-react';

export interface LanguagesSectionProps {
  languages: string[];
  yearsOfExperience: number;
}

export const LanguagesSection: FC<LanguagesSectionProps> = ({
  languages,
  yearsOfExperience,
}) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-4 flex items-center gap-2">
        <Globe className="w-5 h-5" />
        Languages
      </h3>
      <div className="flex flex-wrap gap-2">
        {languages.length > 0 ? (
          languages.map((language) => (
            <span
              key={language}
              className="px-3 py-1 rounded-full text-sm bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-slate-300"
            >
              {language}
            </span>
          ))
        ) : (
          <p className="text-gray-500 dark:text-slate-400 text-sm italic">
            No languages specified
          </p>
        )}
      </div>
      <p className="text-xs text-gray-500 dark:text-slate-500 mt-3">
        {yearsOfExperience} years of experience
      </p>
    </div>
  );
};
